export default {
  methods: {
    couponSuccessResponse(coupon) {
      let status_text = "Koden, du har modtaget, giver dig ";

      if (coupon.percent_off && coupon.percent_off > 0) {
        status_text += `${coupon.percent_off}% rabat`;

        if (coupon.duration_in_months) {
          if (coupon.duration_in_months > 0) {
            status_text += ` i ${coupon.duration_in_months} ${
              coupon.duration_in_months > 1 ? "måneder" : "måned"
            }`;
          } else if (coupon.duration && coupon.duration == "forever") {
            status_text += ` altid`;
          } else if (coupon.duration && coupon.duration == "once") {
            status_text += ` på din første betaling`;
          }
        }
      }

      status_text += `. Dit abonnement vil derfor koste `;

      if (coupon.duration && coupon.duration != "forever") {
        status_text += `${Math.round(
          59 - (59 / 100) * coupon.percent_off
        )} kroner `;
        status_text += `${
          coupon.duration_in_months == 1 || coupon.duration_in_months == null
            ? "første måned"
            : "pr. md. de første " + coupon.duration_in_months + " måneder. "
        }`;
        status_text += `Herefter 59 kroner pr. md.`;
      }

      if (coupon.duration && coupon.duration == "forever") {
        status_text += `${59 -
          (59 / 100) * coupon.percent_off} kroner indtil, du stopper det.`;
      }

      return status_text;
    },
  },
};
